import LocalizedStrings from 'react-localization';

export let strings = new LocalizedStrings({
    en: {
        button: {
            text: 'Create new bot'
        }
    },
    es: {
        button: {
            text: 'Nuevo bot'
        }
    }
});


// WEBPACK FOOTER //
// ./src/redux/components/pages/DashboardBots/DashboardBotsContent.js